import cx from 'classnames'
import { Heading } from 'almanac-ui/Heading/Heading'
import Styles from './Field.module.scss'
import { FieldProps } from './Types'

const Field = ({ label, children, description, isRequired = false, direction = 'column' }: FieldProps) => {
  const title = (
    <span>
      {label}
      {isRequired && <span className={Styles.star}>&nbsp;*</span>}
    </span>
  )

  return (
    <div className={Styles.fieldContainer}>
      <div className={cx(Styles.field, Styles[direction])} data-testid="field">
        {(label || description) && (
          <div className={Styles.fieldWrapper} data-testid="fieldWrapper">
            <div className={Styles.labelAndDescription}>
              <div className={Styles.headingWrapper}>
                <Heading level={4}>{title}</Heading>
              </div>
              {description && <div className={Styles.description}>{description}</div>}
            </div>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  )
}

export { Field }
